import { FC } from "react";

import { getDonationFormCanonicalTags } from "@simplyk/common";

import { ZeffyHead } from "../ZeffyHead";

import { DonationFormMetaContentType, useDonationFormMetaContent } from "./useDonationFormMetaContent";

import { useDonationFormTranslationField } from "@/hooks/useDonationTranslation";
import { DonationFormFrontendPageOutput } from "@/types/trpc";

interface DonationFormHeadProps {
  donationForm: DonationFormFrontendPageOutput;
  metaContentType: DonationFormMetaContentType;
}

export const DonationFormHead: FC<DonationFormHeadProps> = ({ donationForm, metaContentType = "donationForm" }) => {
  const { donationFormField } = useDonationFormTranslationField(donationForm);

  const title = donationFormField?.title;
  const description = donationFormField?.description;

  const { metaTitle, metaDescription } = useDonationFormMetaContent({
    donationForm,
    metaContentType,
    title,
  });

  const frontendUrl = process.env.NEXT_PUBLIC_FRONTEND_URL as string;

  return (
    <ZeffyHead
      title={title}
      description={description}
      metaTitle={metaTitle}
      metaDescription={metaDescription}
      canonicalTags={getDonationFormCanonicalTags({
        frontendUrl,
        donationForm,
        fieldsLocales: donationForm.donationFormFields.map((field) => field.locale),
        country: donationForm.organization?.country,
      })}
      image={donationForm.bannerUrl || donationForm.logoUrl || undefined}
      video={donationForm.bannerVideoUrl || undefined}
      noIndex={Boolean(
        donationForm.organization?.fraudulent ||
          donationForm.organization?.isDeleted ||
          !donationForm.organization?.isStripeCustomAccountActive
      )}
    />
  );
};
